import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './Anchor.scss.js';

const bem = Bem.create("vai-anchor");
const Anchor = (props) => {
  const { htmlId, fontSize, openInNewWindow, dataTa, to, children, tabIndex } = props;
  const id = useId(htmlId, ["anchor"]);
  const target = openInNewWindow ? "_blank" : "_self";
  const rel = openInNewWindow ? "noopener" : "";
  const conditionalProps = {
    rel,
    target,
    tabIndex,
    "data-ta": dataTa
  };
  const onClick = (e) => {
    const { preventDefault } = props;
    if (preventDefault) {
      e.preventDefault();
    }
    if (props.onClick) {
      props.onClick(e);
    }
  };
  const className = addClass(bem.block(fontSize && `font-size-${fontSize}`), props.className);
  return /* @__PURE__ */ React.createElement("a", {
    id: id.toString(),
    className,
    href: to,
    onClick,
    ...conditionalProps
  }, children);
};

export { Anchor };
